/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponLinkViewModel } from "../types/CouponLinkViewModel.ts";
import { couponLinkLangViewModelSchema } from "./couponLinkLangViewModelSchema.ts";

export const couponLinkViewModelSchema = z.object({
  classStudentId: z.optional(z.number().int().describe("ID da turma do link.")),
  classStudentCode: z.string().describe("Código da turma do link.").nullish(),
  linkLang: z
    .array(z.lazy(() => couponLinkLangViewModelSchema))
    .describe("Links da turma, um para cada idioma disponível.")
    .nullish(),
}) as unknown as ToZod<CouponLinkViewModel>;
